import { TableCell, TableRow } from 'components/infinite_data_source_table/styled';
import { BaseWidgetContainer } from 'components/page/BaseLandingPage';
import { SpinnerArea } from 'components/spinner/SpinnerArea';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled(BaseWidgetContainer)`
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;

export const Title = styled.h2`
    color: ${tokens.text.primary};
    font-size: 2.4rem;
    font-weight: 500;
    line-height: 1.25;
    margin: 0;
`;

export const StyledSpinnerArea = styled(SpinnerArea)`
    padding: 4rem 0;
`;

export const CenteredTableRow = styled(TableRow)`
    height: 24rem;
`;

export const CenteredTableCell = styled(TableCell)`
    text-align: center;
    vertical-align: middle;
    border-bottom: none;
`;

export const HeaderText = styled.span`
    display: inline-block;
    line-height: 1.6rem;
    white-space: pre-line;
`;

export const LocationText = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    flex: 1 1 0%;
    min-width: 0;
    overflow-wrap: anywhere;
`;
